import './style/main.css';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import EnvironementGenerator from './js/EnvironementGenerator.js';
import UIGenerator from './js/UIGenerator.js';
import {CSS2DRenderer, CSS2DObject} from 'three/examples/jsm/renderers/CSS2DRenderer.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';

const screensizes = {};
const canvas = document.querySelector('.webgl');
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
});

const screenMDP = [80, 68, 70, 67];
const adminMDP = [65, 68, 77, 73, 78];
var currentIdScreenMDP = 0;
var currentIdAdminMDP = 0;
var adminMode = false;

const labelRenderer = new CSS2DRenderer();

var scene = new THREE.Scene();
var axesHelper = new THREE.AxesHelper( 5 );

const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 10000 );
const uiCamera = new THREE.OrthographicCamera(-window.innerWidth / 2, window.innerWidth / 2, window.innerHeight / 2, -window.innerHeight / 2, -1000, 1000);
const controls = new OrbitControls( camera, renderer.domElement );


//adminMode = true;
if (adminMode) {
    controls.mouseButtons.LEFT = null; // Désactive le clic gauche orbital
    controls.mouseButtons.RIGHT = THREE.MOUSE.ROTATE; // Active la rotation orbital avec clic droit
}



var pointLight = new THREE.PointLight( 0xffffff);
const ambLight = new THREE.AmbientLight();
var spotLight = new THREE.SpotLight( 0xffffff);



//VARIABLES POUR OUTLINE

const renderTarget = new THREE.WebGLRenderTarget(window.innerWidth, window.innerHeight, {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter,
    format: THREE.RGBAFormat
});

const composer = new EffectComposer(renderer, renderTarget);
composer.setPixelRatio(window.devicePixelRatio);
composer.setSize(window.innerWidth, window.innerHeight);
const renderPass = new RenderPass(scene, camera);
composer.addPass(renderPass);

const outlinePass = new OutlinePass(
    new THREE.Vector2(window.innerWidth, window.innerHeight),
    scene,
    camera
);
composer.addPass(outlinePass);

// Amélioration anti-aliasing
const fxaaPass = new ShaderPass(FXAAShader);
fxaaPass.uniforms['resolution'].value.set(1 / window.innerWidth, 1 / window.innerHeight);
composer.addPass(fxaaPass);

// Personnalisation du contour
outlinePass.edgeStrength = 5; // Intensité de l'outline
outlinePass.edgeGlow = 0;   // Effet de glow
outlinePass.edgeThickness = 0.5; // Épaisseur de l'outline
outlinePass.pulsePeriod = 0;  // Effet de pulsation (0 = désactivé)
outlinePass.visibleEdgeColor.set('#FFFFFF');  // Couleur de l'outline
outlinePass.hiddenEdgeColor.set('#000000');  // Couleur de l'outline caché



baseSetup();


const room = document.getElementById('room');

//Récupération des data de l'URL
let params = new URLSearchParams(location.search);
var data = {};
if (params.get('r')) {
    //data.e = params.get('e');
    data.r = params.get('r');
    data.c = params.get('c');;
    data.d = JSON.parse(params.get('d'));
}

var clock = new THREE.Clock();
var playAnimation = false;
var tribuneOuverte = true;
var tribuneOuverteToSet = true;
var firstPersonCam = false;
var firstPersonCamBeforeScreen = false;
let isMouseDown = false;
let previousMousePosition = {
  x: 0,
  y: 0
};
var mapManager;
var uiGenerator;
var currentRoom;
currentRoom = room.value;
var uiObject;
var clickStartTime;
var mouse = new THREE.Vector2();
var measureGeneration = false;

//Loadscreen
const loadManager = new THREE.LoadingManager();
loadManager.onStart = function ( url, itemsLoaded, itemsTotal ) {
    var elem = document.getElementById("image-overlay");
    elem.style.animation = 'none'; // Supprimez l'animation actuelle
    void elem.offsetWidth; // Cela force un repaint (redraw) de l'élément
    elem.style.animation = 'fadeOut 1s forwards';
    elem.style.animationPlayState = "paused";
};

loadManager.onLoad = function ( ) {
    var elem = document.getElementById("image-overlay");
    elem.style.animationPlayState = "running";
    
};

loadManager.onProgress = function ( url, itemsLoaded, itemsTotal ) {
};

loadManager.onError = function ( url ) {
};

//Utilisation des data de l'URL
if (data.r) {
    currentRoom= data.r;
    room.value = data.r;
    if (data.c) {
        mapManager = new EnvironementGenerator(data.r, scene, loadManager, camera, outlinePass, canvas, adminMode, data);
        uiGenerator = new UIGenerator(scene, data.r, mapManager, data);
    }
    else {
        mapManager = new EnvironementGenerator(data.r, scene, loadManager, camera, outlinePass, canvas, adminMode);
        uiGenerator = new UIGenerator(scene, data.r, mapManager);
    }
}
else {

    mapManager = new EnvironementGenerator(currentRoom, scene, loadManager, camera, outlinePass, canvas, adminMode);

    uiGenerator = new UIGenerator(scene, currentRoom, mapManager);
}

//Generation modèles
//mapManager.ShowMap();
//Generation UI
uiGenerator.SetupUI(adminMode);

//The loop
const loop = () =>
{
    if (firstPersonCam) {

    }
    else {
        controls.update();
    }


    // Render
    //renderer.render(scene, camera);
    composer.render();

    labelRenderer.render(scene, uiCamera);

    
    //Changement de modèles
    if (currentRoom != room.value){
        currentRoom = room.value;
        changeModel();
    }

    //Changement de type de caméra
    var camType = document.getElementById("cam-type");
    if (camType) {
        if (camType.checked != firstPersonCam) {
            switchCamera();
        }
    }

    //Si lully, gestion de l'anim de la tribune
    if (currentRoom == "Lully") {
        var roomType = document.getElementById("config-type");
        if (roomType) {
            if (roomType.value == "Theatre" && !tribuneOuverte && mapManager.setupEnd) {
                tribuneOuverte = true;
                playAnimation = true;
            }
            else if (roomType.value != "Theatre" && tribuneOuverte && mapManager.setupEnd) {
                tribuneOuverte = false;
                playAnimation = true;
            }
        }
    }
    var dt = clock.getDelta();
    if (playAnimation) {
        playAnimation = mapManager.PlayAnimation(dt, tribuneOuverte);
    }

    //Creation de l'image avec les mesures
    if (measureGeneration) {
        if (mapManager.allMeasureDone()) {
            if (firstPersonCam) {
                firstPersonCamBeforeScreen = true;
                switchCamera();
            }
            createImage();
            measureGeneration = false;
        }
    }

    // Keep looping
    window.requestAnimationFrame(loop);
}
loop();


//Changement de caméra
function switchCamera() {
    firstPersonCam = !firstPersonCam;
    mapManager.SwitchView(firstPersonCam, camera);

    if (firstPersonCam) {
        controls.enabled = false;
    }
    else {
        controls.enabled = true;
        camera.position.set( 0, 20, 50 );

    }
}

//Changement de caméra
function updateCameraFromMouseMovement(event) {
    if (isMouseDown) {
        const movementX = event.clientX - previousMousePosition.x;
        const movementY = event.clientY - previousMousePosition.y;

        const rotationSpeed = 0.002;
        camera.rotation.y -= movementX * rotationSpeed;
        camera.rotation.x -= movementY * rotationSpeed;

        previousMousePosition.x = event.clientX;
        previousMousePosition.y = event.clientY;
    }
}

//Setup de base de l'appli
function baseSetup()
{
    screensizes.width = window.innerWidth * 0.95;
    screensizes.height = window.innerHeight * 0.95;

    //Setup render
    
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(screensizes.width, screensizes.height);
    renderer.setClearColor( 0xffffff, 1);

    //Render UI bouton menu
    var height = 400;
    var width = 350;
    labelRenderer.setSize(width, height);
    labelRenderer.domElement.style.position = 'absolute';
    labelRenderer.domElement.style.top = canvas.getBoundingClientRect().top + "px";
    labelRenderer.domElement.style.left = (canvas.getBoundingClientRect().width - width) + "px";
    labelRenderer.domElement.style.pointerEvents = "none";
    document.body.appendChild(labelRenderer.domElement);


    //Resize listener
    window.addEventListener('resize', () =>
    {
        screensizes.width = window.innerWidth * 0.95;
        screensizes.height = window.innerHeight * 0.95;

        camera.aspect = screensizes.width / screensizes.height;
        camera.updateProjectionMatrix();

        renderer.setSize(screensizes.width, screensizes.height);

        var height = 400;
        var width = 350;
        labelRenderer.setSize(width, height);
        labelRenderer.domElement.style.top = canvas.getBoundingClientRect().top + "px";
        labelRenderer.domElement.style.left = (canvas.getBoundingClientRect().width - width) + "px";
    });

    /**
     * Environnements
     */

    // Camera
    
    camera.position.set( 0, 20, 50 );
    controls.update();
    controls.mouseButtons.MIDDLE = THREE.MOUSE.PAN;
    controls.addEventListener('change', () => {
        const limit = 50; // Distance max autorisée depuis l'origine

        controls.target.clamp(
            new THREE.Vector3(-limit, -limit, -limit),
            new THREE.Vector3(limit, limit, limit)
        );
    });
    controls.maxPolarAngle = Math.PI/2;
    controls.enableDamping = true;
    controls.dampingFactor = 0.1;
    scene.add(camera);

    // Lights
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);

    const dirLight = new THREE.DirectionalLight(0xffffff, 0.8);
    dirLight.position.set(50, 100, 50);
    dirLight.castShadow = true;
    dirLight.shadow.mapSize.width = 2048;
    dirLight.shadow.mapSize.height = 2048;
    dirLight.shadow.camera.near = 0.1;
    dirLight.shadow.camera.far = 500;
    dirLight.shadow.camera.left = -30;
    dirLight.shadow.camera.right = 30;
    dirLight.shadow.camera.top = 30;
    dirLight.shadow.camera.bottom = -30;
    scene.add(dirLight);

    const dirLight2 = new THREE.DirectionalLight(0xffffff, 0.8);
    dirLight2.position.set(-50, 100, -50);
    dirLight2.castShadow = false;/*
    dirLight2.shadow.mapSize.width = 2048;
    dirLight2.shadow.mapSize.height = 2048;
    dirLight2.shadow.camera.near = 0.1;
    dirLight2.shadow.camera.far = 500;
    dirLight2.shadow.camera.left = -10;
    dirLight2.shadow.camera.right = 10;
    dirLight2.shadow.camera.top = 10;
    dirLight2.shadow.camera.bottom = -10;*/
    scene.add(dirLight2);

    const dirLight3 = new THREE.DirectionalLight(0xffffff, 0.3);
    dirLight3.position.set(0, 100, 0);
    dirLight3.castShadow = true;
    dirLight3.shadow.mapSize.width = 2048;
    dirLight3.shadow.mapSize.height = 2048;
    dirLight3.shadow.camera.near = 0.1;
    dirLight3.shadow.camera.far = 500;
    dirLight3.shadow.camera.left = -30;
    dirLight3.shadow.camera.right = 30;
    dirLight3.shadow.camera.top = 30;
    dirLight3.shadow.camera.bottom = -30;
    scene.add(dirLight3);


    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
}

//Chagement de modèle
function changeModel() {
    scene = new THREE.Scene();

    renderPass.scene = scene;
    outlinePass.selectedObjects = []; // Vider la sélection d'objets outline
    outlinePass.scene = scene;
    outlinePass.renderScene = scene; // Mettre à jour la scène de l’OutlinePass
    composer.passes = []; // Réinitialiser les passes du composer

    composer.addPass(renderPass);
    composer.addPass(outlinePass);
    composer.addPass(fxaaPass);


    baseSetup();
    mapManager = new EnvironementGenerator(currentRoom, scene, loadManager, camera, outlinePass, canvas, adminMode);

    uiGenerator.ClearUI();
    uiGenerator = new UIGenerator(scene, currentRoom, mapManager);

    uiGenerator.SetupUI(adminMode);
}

//Definir si la tribune est ouverte ou fermée
function changeTribune(value) {
    tribuneOuverteToSet = value;
}

// Événements de clic de souris
document.addEventListener('mousedown', function(event) {
    isMouseDown = true;
    previousMousePosition.x = event.clientX;
    previousMousePosition.y = event.clientY;
    clickStartTime = performance.now();
});

document.addEventListener('mouseup', function() {
    isMouseDown = false;
    if (clickStartTime) {
        const clickDuration = performance.now() - clickStartTime; // Calcul de la durée du clic en millisecondes
        if (clickDuration < 120) {
            if (!isMouseOverUI(event)) {
                mapManager.Clicked(mouse);
            }
        }
    }
});

function isMouseOverUI(event) {
    return event.target.closest('.base-ui-show') !== null; // Vérifie si l'élément appartient à l'UI
}

document.addEventListener('mousemove', updateCameraFromMouseMovement, false);
document.addEventListener('mousemove', onMouseMove, false);
document.addEventListener("keydown", onDocumentKeyDown, false);

function onDocumentKeyDown(event) {
    var keyCode = event.which;
    if (keyCode == screenMDP[currentIdScreenMDP]) {
        if (currentIdScreenMDP == 3) {
            mapManager.AddMeasureForScreen();
            measureGeneration = true;
            currentIdScreenMDP = 0;
        }
        else {
            currentIdScreenMDP++;
        }
    }
    else {
        currentIdScreenMDP = 0;
    }

    if (keyCode == adminMDP[currentIdAdminMDP]) {
        if (currentIdAdminMDP == 4) {
            adminMode = true;
            controls.mouseButtons.LEFT = null; // Désactive le clic gauche orbital
            controls.mouseButtons.RIGHT = THREE.MOUSE.ROTATE; // Active la rotation orbital avec clic droit
            var defaultRoom = mapManager.roomConfig;
            mapManager.SetAdmin(adminMode);
            uiGenerator.ClearUI();
            uiGenerator.SetupUI(adminMode, defaultRoom);
            currentIdAdminMDP = 0;
        }
        else {
            currentIdAdminMDP++;
        }
    }
    else {
        currentIdAdminMDP = 0;
    }
};

function onMouseMove(event) {
    // Normaliser les coordonnées de la souris (-1 à 1)
    /*mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;*/


    const rect = canvas.getBoundingClientRect(); // Récupère la position et taille du canvas
    const x = event.clientX - rect.left; // Coordonnée X relative au canvas
    const y = event.clientY - rect.top;  // Coordonnée Y relative au canvas

    // Convertir en coordonnées normalisées (-1 à 1) pour Three.js
    mouse.x = (x / rect.width) * 2 - 1;
    mouse.y = -(y / rect.height) * 2 + 1;
}

function createImage() {
    //const width = window.innerWidth;
    const width = 1920;
    const height = 969;
    //const height = window.innerHeight;

    // Définir les dimensions de la vue en unités de scène
    const viewWidth = 50; // Largeur de la vue
    const aspectRatio = width / height;
    const viewHeight = viewWidth / aspectRatio;

    // Créer la caméra orthographique
    var cameraScreen = new THREE.OrthographicCamera(
      viewWidth / -2, // left
      viewWidth / 2, // right
      viewHeight / 2, // top
      viewHeight / -2, // bottom
      0.1, // near
      100 // far
    );

    // Positionner la caméra
    cameraScreen.position.set(0, 10, 0); // ajustez la position selon vos besoins
    cameraScreen.lookAt(0, 0, 0); // ajustez la cible de la caméra selon vos besoins

    if (mapManager.name == "Room_8_11") {
        cameraScreen.rotation.z = -Math.PI/2;
    }

    const imageRenderer = new THREE.WebGLRenderer({ antialias: true });
    imageRenderer.setSize(width, height);
    imageRenderer.setPixelRatio(window.devicePixelRatio * 2);
    imageRenderer.setClearColor( 0xffffff, 1);
    //imageRenderer.setClearColorHex( 0xffffff, 1 );
    //document.body.appendChild(imageRenderer.domElement);

    imageRenderer.render(scene, cameraScreen);
    var imgData = imageRenderer.domElement.toDataURL();
    var a = document.createElement('a');
    a.href = imgData;
    a.download = "VueDessus.png";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    mapManager.ClearMeasureForScreen();

    if (firstPersonCamBeforeScreen) {
        firstPersonCamBeforeScreen = false;
        switchCamera();
    }
}